import {extend} from "vee-validate";
import ui from "@/assets/scripts/ui";

const messageDefault = " inválido"

let manualErrorMessage = ""

const manualRule = {

    validate(value, args) {

        manualErrorMessage = args[0]

        return {
            valid: false, // or false
            data: {
                required: true // or false
            }
        }
    },

    computesRequired: true,

    message() {
        return manualErrorMessage
    }
}

const timeRule = {

    validate(value) {
        return value.match(/^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/g)
    },
    message() {
        return 'Horário inválido'
    }

}

const numericNotZeroRule = {

    validate(value) {
        return value > 0
    },
    message() {
        return 'Valor deve ser maior que zero'
    }

}



const dateRule = {

    validate(value) {

        if (value && value !== "" && value.length === 10) {

            let convert_date = value

            if (convert_date.indexOf('T') < 0)
                convert_date += 'T00:00:00'

            const v = ui.convertDateBR(convert_date)

            let ano_bissexto;
            const expReg = /^(([0-2]\d|[3][0-1])\/([0]\d|[1][0-2])\/[1-2][0-9]\d{2})$/;

            if ((v.match(expReg)) && (v !== '')) {

                const dia = v.substring(0, 2);
                const mes = v.substring(3, 5);
                const ano = v.substring(6, 10);


                if (((!(ano % 4)) && (ano % 100)) || (!(ano % 400))) {
                    ano_bissexto = true;
                } else {
                    ano_bissexto = false;
                }

                if ((mes == 4 || mes == 6 || mes == 9 || mes == 11) && dia > 30) {

                    //Meses com dias inválidos
                    return false

                } else {
                    if (!ano_bissexto && mes == 2 && dia > 28) {
                        //"Data incorreta! O mes especificado contem no máximo 28 dias.\nInsira novamente");

                    } else {
                        if (ano_bissexto && mes == 2 && dia > 29) {

                            //"Data incorreta! O mes especificado contem no máximo 29 dias.\nInsira novamente");
                            return false

                        } else {
                            return true
                        }
                    }
                }
            } else {
                //Data invalida geral
                return false
            }

            return true
        } else {
            return true
        }

    }
}

const urlRule = {

    validate(value) {
        return value.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g)
    },
    message() {
        return 'URL inválida'
    }

}

const passwordSecurityRule = {

    validate(value) {
        return value.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/g)
    },
    message() {
        return 'Informe uma senha com no mínimo 8 caracteres, letras maiúsculas e minúsculas, números e pelo menos 1(um) caracter especial (#,@,?,...)'
    }

}



const emailMultipleRule = {

    validate(value) {

        let v = value
        let validate = true
        const filter = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;

        if (v && v.length > 0) {

            const matriz = v.replace(/,/g, ';').replace(/;;/g, ';').replace(/ /g, '').split(';');

            for (let i = 0; i < matriz.length; i++) {

                const email = matriz[i];

                if (email !== "") {

                    if (!filter.test(email)) {
                        validate = false
                    }

                }
            }

            return validate

        } else {
            return true
        }

    }
};

const cnpjRule = {

    validate(value) {

        if (!value) return false

        // Aceita receber o valor como string, número ou array com todos os dígitos
        const isString = typeof value === 'string'
        const validTypes = isString || Number.isInteger(value) || Array.isArray(value)

        // Elimina valor em formato inválido
        if (!validTypes) return false

        // Filtro inicial para entradas do tipo string
        if (isString) {
            // Limita ao máximo de 18 caracteres, para CNPJ formatado
            if (value.length > 18) return false

            // Teste Regex para veificar se é uma string apenas dígitos válida
            const digitsOnly = /^\d{14}$/.test(value)
            // Teste Regex para verificar se é uma string formatada válida
            const validFormat = /^\d{2}.\d{3}.\d{3}\/\d{4}-\d{2}$/.test(value)

            // Se o formato é válido, usa um truque para seguir o fluxo da validação
            if (digitsOnly || validFormat) true
            // Se não, retorna inválido
            else return false
        }

        // Guarda um array com todos os dígitos do valor
        const match = value.toString().match(/\d/g)
        const numbers = Array.isArray(match) ? match.map(Number) : []

        // Valida a quantidade de dígitos
        if (numbers.length !== 14) return false

        // Elimina inválidos com todos os dígitos iguais
        const items = [...new Set(numbers)]
        if (items.length === 1) return false

        // Cálculo validador
        const calc = (x) => {
            const slice = numbers.slice(0, x)
            let factor = x - 7
            let sum = 0

            for (let i = x; i >= 1; i--) {
                const n = slice[x - i]
                sum += n * factor--
                if (factor < 2) factor = 9
            }

            const result = 11 - (sum % 11)

            return result > 9 ? 0 : result
        }

        // Separa os 2 últimos dígitos de verificadores
        const digits = numbers.slice(12)

        // Valida 1o. dígito verificador
        const digit0 = calc(12)
        if (digit0 !== digits[0]) return false

        // Valida 2o. dígito verificador
        const digit1 = calc(13)
        return digit1 === digits[1]

    },
    message(field) {
        return field + messageDefault
    }
}

const cpfRule = {

    validate(value) {

        let cpf = value

        // Validar se é String
        if (typeof cpf !== 'string') return false

        // Tirar formatação
        cpf = cpf.replace(/[^\d]+/g, '')

        // Validar se tem tamanho 11 ou se é uma sequência de digitos repetidos
        if (cpf.length !== 11 || !!cpf.match(/(\d)\1{10}/)) return false

        // String para Array
        cpf = cpf.split('')

        const validator = cpf
            // Pegar os últimos 2 digitos de validação
            .filter((digit, index, array) => index >= array.length - 2 && digit)
            // Transformar digitos em números
            .map(el => +el)

        const toValidate = pop => cpf
            // Pegar Array de items para validar
            .filter((digit, index, array) => index < array.length - pop && digit)
            // Transformar digitos em números
            .map(el => +el)

        const rest = (count, pop) => (toValidate(pop)
                // Calcular Soma dos digitos e multiplicar por 10
                .reduce((soma, el, i) => soma + el * (count - i), 0) * 10)
            // Pegar o resto por 11
            % 11
            // transformar de 10 para 0
            % 10

        return !(rest(10, 2) !== validator[0] || rest(11, 1) !== validator[1])


    },
    message(field) {
        return field + messageDefault
    }
}


const cepRule = {

    validate(value) {

        if (value && value !== "" && value.length < 9) {
            return false
        } else {
            return true
        }
    },
    message(field) {
        return field + messageDefault
    }


}

const colorRule = {

    validate(value) {
        return value.length === 7
            && !isNaN(Number('0x' + value.replace('#','')))
    },
    message() {
        return 'Aceito somente cores em hexadecimal'
    }

}

const numbersRule = {

    validate(value) {
        return value.match(/^\d+$/i)
    },
    message() {
        return 'Aceito somente números'
    }

}

const lettersRule = {

    validate(value) {
        return value.match(/^[A-Za-z]+$/)
    },
    message() {
        return 'Aceito somente letras'
    }

}

const lettersAndNumbersRule = {

    validate(value) {
        return value.match(/^[A-Za-z\d]+$/i);
    },
    message() {
        return 'Aceito letras e números sem acentuação'
    }

}

extend('manual_rule', manualRule);
extend('numeric_not_zero', numericNotZeroRule);
extend('date', dateRule);
extend('time', timeRule);
extend('email_multiple', emailMultipleRule);
extend('url', urlRule);
extend('cnpj', cnpjRule);
extend('cpf', cpfRule);
extend('cep', cepRule);
extend('only_numbers', numbersRule);
extend('only_letters', lettersRule);
extend('only_letters-and-numbers', lettersAndNumbersRule);
extend('color', colorRule);
extend('password_security', passwordSecurityRule);








